module.exports = __webpack_public_path__ + "img/mars.2a770992.svg";